import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { AuditEventTypeEnumDescriptionService } from './audit-events';

@Component({
    selector: 'app-audit-logs',
    templateUrl: './audit-logs.component.html',
    styleUrls: ['./audit-logs.component.scss'],
    standalone: false
})
export class AuditLogsComponent {
 
 auditlogVisible: boolean = false;
 @Input() auditLogs: any[] = [];
  
  columnsToDisplay = ['User', 'Date','Event', 'Details']

  constructor(public enumdescservice:AuditEventTypeEnumDescriptionService,public datePipe:DatePipe){}

  ngOnInit(): void {
   
  }
  checkIfValidDate(inputString: string): string {
    const date = new Date(inputString);
    // Check if the date is valid and inputString does not contain non-numeric characters
    if(!isNaN(date.getTime()) && /^\d/.test(inputString))
    {
      return this.datePipe.transform(inputString,'dd/MM/yyyy hh:mm')?.toString()!
    }
    else
    {
return inputString;
    }
  }
}
